require('../../modules/es6.string.code-point-at');
module.exports = require('../../modules/_core').String.codePointAt;


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/fn/string/code-point-at.js
// module id = Yx9Z
// module chunks = 1